import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from '../shared/AnimatedSection';
import { GlowCard } from '../shared/GlowCard';
import { Sign } from '../../data/signs';
interface SignDescubrirProps {
  sign: Sign;
}
const INCLUDED = ['Perfil profundo del arquetipo', 'Energía dominante', 'Patrones emocionales', 'Lado oculto', 'Compatibilidad base', 'Frases de identidad', 'Ritual simbólico'];
export function SignDescubrir({
  sign
}: SignDescubrirProps) {
  const items = sign.content.descubriras;
  return <section className="py-20 px-6 bg-cosmic-black" data-id="element-331">
      <div className="container mx-auto max-w-5xl" data-id="element-332">
        <AnimatedSection data-id="element-333">
          {/* Intro text above title */}
          <div className="text-center mb-6" data-id="element-334">
            <motion.div className="inline-flex items-center gap-3 mb-5" initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} data-id="element-335">
              <div className="h-px w-10" style={{
              background: `linear-gradient(90deg, transparent, ${sign.colors.primary})`
            }} data-id="element-336" />
              <span className="text-[10px] tracking-[0.4em] uppercase font-serif" style={{
              color: sign.colors.accent
            }} data-id="element-337">
                El Núcleo
              </span>
              <div className="h-px w-10" style={{
              background: `linear-gradient(90deg, ${sign.colors.primary}, transparent)`
            }} data-id="element-338" />
            </motion.div>
            <p className="max-w-2xl mx-auto text-base md:text-lg font-serif italic leading-relaxed mb-10" style={{
            color: `${sign.colors.accent}E0`,
            textShadow: `0 0 20px ${sign.colors.primary}30`
          }} data-id="element-339">
              El Núcleo del Arquetipo explora los patrones, emociones y energía
              que definen la esencia de tu entidad.
            </p>
          </div>

          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-white mb-16" data-id="element-340">
            Qué Descubrirás
          </h2>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-341">
          {items.map((item, index) => <AnimatedSection key={index} delay={0.15 + index * 0.08} data-id="element-342">
              <GlowCard glowColor={sign.colors.primary} className="h-full flex items-center" data-id="element-343">
                <div className="flex items-start" data-id="element-344">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 mr-4" style={{
                backgroundColor: `${sign.colors.primary}25`,
                border: `2px solid ${sign.colors.primary}`,
                boxShadow: `0 0 15px ${sign.colors.primary}40`
              }} data-id="element-345">
                    <span style={{
                  color: sign.colors.accent
                }} className="font-bold font-serif" data-id="element-346">
                      {index + 1}
                    </span>
                  </div>
                  <p className="text-gray-200 leading-relaxed pt-1" data-id="element-347">{item}</p>
                </div>
              </GlowCard>
            </AnimatedSection>)}
        </div>

        {/* "Incluido dentro del Núcleo" — premium informational block */}
        <AnimatedSection delay={0.4} data-id="element-348">
          <div className="mt-20 max-w-4xl mx-auto" data-id="element-349">
            <div className="text-center mb-10" data-id="element-350">
              <motion.div className="inline-flex items-center gap-3 mb-5" initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} data-id="element-351">
                <div className="h-px w-10" style={{
                background: `linear-gradient(90deg, transparent, ${sign.colors.primary})`
              }} data-id="element-352" />
                <span className="text-[10px] tracking-[0.4em] uppercase font-serif" style={{
                color: sign.colors.accent
              }} data-id="element-353">
                  Contenido del Archivo
                </span>
                <div className="h-px w-10" style={{
                background: `linear-gradient(90deg, ${sign.colors.primary}, transparent)`
              }} data-id="element-354" />
              </motion.div>
              <h3 className="text-2xl md:text-3xl font-serif font-semibold text-white" data-id="element-355">
                Incluido dentro del Núcleo
              </h3>
            </div>

            <div className="relative rounded-2xl p-8 md:p-10 overflow-hidden" style={{
            background: `linear-gradient(160deg, rgba(10,10,18,0.85) 0%, ${sign.colors.primary}10 100%)`,
            border: `1px solid ${sign.colors.primary}35`,
            boxShadow: `0 0 40px ${sign.colors.primary}20, inset 0 0 30px ${sign.colors.primary}08`
          }} data-id="element-356">
              {/* Pulsing ambient glow */}
              <motion.div className="absolute inset-0 rounded-2xl pointer-events-none" animate={{
              opacity: [0.3, 0.55, 0.3]
            }} transition={{
              duration: 5,
              repeat: Infinity,
              ease: 'easeInOut'
            }} style={{
              boxShadow: `inset 0 0 50px ${sign.colors.primary}20`
            }} data-id="element-357" />

              <ul className="relative grid grid-cols-1 md:grid-cols-2 gap-x-10" data-id="element-358">
                {INCLUDED.map((item, i) => <motion.li key={item} initial={{
                opacity: 0,
                x: -10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.1 + i * 0.08
              }} className="flex items-center py-3.5 group" style={{
                borderBottom: i < INCLUDED.length - (INCLUDED.length % 2 === 0 ? 2 : 1) ? `1px solid ${sign.colors.primary}20` : 'none'
              }} data-id="element-359">
                    {/* Glowing diamond bullet */}
                    <div className="relative flex-shrink-0 mr-4 w-3 h-3" data-id="element-360">
                      <motion.div className="absolute inset-0" animate={{
                    rotate: 360
                  }} transition={{
                    duration: 12,
                    repeat: Infinity,
                    ease: 'linear'
                  }} style={{
                    backgroundColor: sign.colors.primary,
                    transform: 'rotate(45deg)',
                    boxShadow: `0 0 10px ${sign.colors.primary}`
                  }} data-id="element-361" />
                    </div>
                    <span className="font-serif text-base md:text-lg tracking-wide" style={{
                  color: '#F5F0E1',
                  textShadow: `0 0 12px ${sign.colors.primary}25`
                }} data-id="element-362">
                      {item}
                    </span>
                  </motion.li>)}
              </ul>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}